// A public seed can temporarily lack a visible category. Only link a complete,
// known category path; keep the seed page and its original content available.
export function plantCategoryPath(category){
 if(!category?.slug?.trim()||!category?.parent?.slug?.trim())return null;
 return `/catalog/${category.parent.slug}/${category.slug}`;
}

export function plantBreadcrumbs(product){
 const trail=[{title:'Главная',href:'/'},{title:'Каталог',href:'/catalog'}];
 const category=product?.category,path=plantCategoryPath(category);
 if(path&&category.parent.title)trail.push({title:category.parent.title,href:`/catalog/${category.parent.slug}`});
 if(path&&category.title)trail.push({title:category.title,href:path});
 if(product?.title)trail.push({title:product.title});
 return trail;
}
